import { useAppSelector } from '../../store/hook';
import { headerOptionsProvider } from '../../store/providers/headerOptionsProvider';
import { useEffect } from 'react';

const useAssessmentHeader = (assessmentHeader: boolean): void => {
  const headerOptions = useAppSelector((state) => state.headerOptions);
  const { isAssessment } = headerOptions;
  const { setHeaderOptions } = headerOptionsProvider();

  useEffect(() => {
    !isAssessment && setHeaderOptions({ ...headerOptions, ...{ isAssessment: assessmentHeader } });
  }, [isAssessment, headerOptions, setHeaderOptions, assessmentHeader]);
};

export default useAssessmentHeader;
